import { createReducer, EntityState } from '@reduxjs/toolkit';

import kioskApi from 'modules/kiosk/service';
import selfServicesApi from 'modules/selfServices/service';
import { slotsAdapter } from 'modules/kiosk/reducers/adapters';
import { SelfServiceOrigin } from 'modules/selfServices/types/SelfService';

import type { AdminSlot } from 'modules/kiosk/types/Slot';

type InitialState = EntityState<AdminSlot, string>;

const slotReducer = createReducer<InitialState>(slotsAdapter.getInitialState(), (builder) => {
  builder
    .addMatcher(
      kioskApi.endpoints.getKioskData.matchFulfilled,
      (state, { payload }) => slotsAdapter.setAll(state, payload.slots),
    )
    .addMatcher(selfServicesApi.endpoints.getSelfServiceById.matchFulfilled, (state, { payload }) => {
      const { id, origin, slot } = payload;
      if (origin === SelfServiceOrigin.KIOSK && slot) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { kiosk, ...newSlot } = slot;
        // `slot` is a PublicSlot (no status/finalized); those are filled in later by getKioskData.
        return slotsAdapter.setOne(state, {
          ...newSlot,
          used: true,
          selfServiceId: id,
        });
      }
      return state;
    })
    .addMatcher(kioskApi.endpoints.openSlot.matchFulfilled, (state, { payload }) => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { kiosk, ...slot } = payload;
      // openSlot returns a PublicSlot (no status/finalized). The upsert merge preserves
      // those fields when the slot was already loaded by getKioskData.
      return slotsAdapter.upsertOne(state, { ...slot, used: true });
    })
    .addMatcher(kioskApi.endpoints.openSlotAsAdmin.matchFulfilled, (state, { payload }) => {
      const { slotId, selfServiceId } = payload;
      return slotsAdapter.updateOne(state, { id: slotId, changes: { selfServiceId } });
    });
});

export default slotReducer;
